import React from "react";
import { Link, location, useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { baseUrl } from "../../api";

import useGlobalStatus from '../../hook/useGlobalStatus';
import theme from '../../theme';

import { PRODUCT_NAME } from '../../constants/global';

import UserProfile from "./UserProfile";
import logo from '../../Logo.png';

import { AppBarStyle, ToolbarStyle, ProductNameStyle } from "./topbarStyle";
import { StackNavIcon } from "../leftnav/leftnavStyle";
import { MenuOutlinedIcon, MenuIcon, MenuOpenIcon } from "../customStyles/images";

const Topbar = (props) => {
  const location = useLocation();
  const { mobileOpen, setMobileOpen, drawerOpen, setDrawerOpen } = useGlobalStatus();
  const theme = useTheme();
  const isMoblie = useMediaQuery(theme.breakpoints.down('lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  const toggleDrawer = (newOpen) => () => {
    setMobileOpen(newOpen);
  };

  const handleDrawerOpen = () => {
    setDrawerOpen(!drawerOpen);
  }

  if (isMoblie) {
    return (
      <Box>
        <AppBarStyle
          id="appbar"
          position="fixed"
          drawer={drawerOpen.toString()}
          sx={{ zIndex: 200 }}
        >
          <Toolbar sx={{ minHeight: '64px' }}>
            <Box
              sx={{
                position: 'absolute',
                left: 0,
              }}
            >
              <MenuOutlinedIcon
                onClick={toggleDrawer(!mobileOpen)}
                sx={{ color: theme.palette.grey.main }}
              />
            </Box>

            <Box sx={{ mx: 'auto' }}>
              <Link
                to="/"
                onClick={(e) => {
                  if (location.pathname === "/") {
                    e.preventDefault();
                  }
                }}
              >
                <img src={logo} alt={PRODUCT_NAME} style={{ width: '150px' }} />
              </Link>
            </Box>
          </Toolbar>
        </AppBarStyle>
      </Box>
    )
  }

  return (
    <Box>
      <AppBarStyle
        component='nav'
        isdesktop={isDesktop.toString()}
        sx={{ zIndex: 1500 }}
      >
        <Toolbar style={ToolbarStyle}>
          <Stack variant="center-center">
            <StackNavIcon variant='end-center'>
              <IconButton
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerOpen}
              >
                <MenuIcon />
              </IconButton>
            </StackNavIcon>

            <Link to="/"
              onClick={(e) => {
                if (location.pathname === "/") {
                  e.preventDefault();
                }
              }}
            >
              <Stack variant="center-center">
                <img src={logo} alt={PRODUCT_NAME} style={{ width: '150px' }} />
                <Typography style={ProductNameStyle}>| 惠比壽日藥直送Chatbot分析</Typography>
              </Stack>
            </Link>
          </Stack>

          <Stack variant='center-center'>
            {baseUrl.version === 'development' &&
              <Typography mr={2}>{baseUrl.versionName}</Typography>
            }
            <UserProfile
              isDesktop={isDesktop}
              isMoblie={isMoblie}
            />
          </Stack>

        </Toolbar>
      </AppBarStyle>
    </Box>
  )
}

export default Topbar;
